import { EVENTS } from '@/lib/consts.ts'
import { DEFAULT_PAYLOAD } from '@/lib/analytics/consts.ts'

export const segment1BooksyCardReader = {
  eventBCRStartedHandler (data) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_STARTED,
      ...payload,
    })
    return {
      event: 'BCR_Started',
    }
  },

  eventBCRVerifyHandler (data) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_VERIFY,
      ...payload,
    })
    return {
      event: 'BCR_Verify',
    }
  },

  eventBCRStripeKYCStartedHandler (data) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_STRIPE_KYC_STARTED,
      ...payload,
    })
    return {
      event: 'BCR_Stripe_KYC_Started',
    }
  },

  eventBCROrderTerminalStartedHandler (data) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_ORDER_TERMINAL_STARTED,
      ...payload,
    })

    return {
      event: 'BCR_Order_Terminal_Started',
    }
  },

  eventBCRBuySubscriptionFromBCRHandler (data) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_BUY_SUBSCRIPTION_FROM_BCR,
      ...payload,
    })
    return {
      event: 'BCR_Buy_Subscription_From_Bcr',
    }
  },

  eventBCRResetAccountStartedHandler (data) {
    const payload = this[DEFAULT_PAYLOAD](data)

    this.identify({
      event_name: EVENTS.BCR_RESET_ACCOUNT_STARTED,
      ...payload,
    })
    return {
      event: 'BCR_Reset_Account_Started',
    }
  },
}
